"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var R = _interopRequireWildcard(require("ramda"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _utils = require("@alycecom/utils");

var _EmailTemplateListItem = _interopRequireDefault(require("../../components/EmailTemplateListItem/EmailTemplateListItem"));

var _templates = require("../../store/templates/templates.actions");

var _templates2 = require("../../store/templates/templates.selector");

var _gift = require("../../store/gift/gift.actions");

var _EmptyListSearch = _interopRequireDefault(require("../../../Shared/components/EmptyListSearch/EmptyListSearch"));

var _SelectItemsList = _interopRequireDefault(require("../../components/SelectItemsList/SelectItemsList"));

var _useTrackGiftingFlow = require("../../hooks/useTrackGiftingFlow");

var _gift2 = require("../../store/gift/gift.selector");

var _invitationType = require("../../store/gift/invitationType");

var _templates3 = require("../../store/templates/templates.constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getTemplateWeight = function getTemplateWeight(template) {
  return R.cond([[R.equals('campaign'), R.always(1)], [R.equals('sample'), R.always(2)], [R.equals('personal'), R.always(3)], [R.equals('team'), R.always(4)], [R.T, R.always(5)]])(template.type);
};

var SelectEmailTemplate = function SelectEmailTemplate(_ref) {
  var giftId = _ref.giftId;

  var _useState = (0, _react.useState)('all'),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      ownerType = _useState2[0],
      setOwnerType = _useState2[1];

  var isLoading = (0, _reactRedux.useSelector)(_templates2.getTemplatesIsLoading);
  var isLoaded = (0, _reactRedux.useSelector)(_templates2.getTemplatesIsLoaded);
  var templates = (0, _reactRedux.useSelector)(_templates2.getTemplateList);
  var isAllowEditTemplate = (0, _reactRedux.useSelector)(_gift2.getIsAllowEditTemplate);
  var isDirectMailInvitationType = (0, _reactRedux.useSelector)(_invitationType.getIsSelectedDirectMailInvitationType);
  var templateTypes = templates.map(function (_ref2) {
    var type = _ref2.type;
    return type;
  });
  var dispatch = (0, _reactRedux.useDispatch)();
  var loadTemplates = (0, _react.useCallback)(function (giftID) {
    return dispatch((0, _templates.loadTemplatesRequest)(giftID));
  }, [dispatch]);
  var setTemplate = (0, _react.useCallback)(function (template) {
    return dispatch((0, _gift.selectTemplate)(template));
  }, [dispatch]);
  var trackStepPassed = (0, _useTrackGiftingFlow.useTrackGiftingFlowSelectTemplatePassed)();
  (0, _react.useEffect)(function () {
    loadTemplates(giftId);
  }, [giftId, loadTemplates]);

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      search = _useState4[0],
      setSearch = _useState4[1];

  var acquiredTemplates = (0, _react.useMemo)(function () {
    var sortedTemplates = R.sortBy(getTemplateWeight, templates);
    var colorList = (0, _utils.getRandomColorList)(sortedTemplates.length);
    return sortedTemplates.map(function (template, index) {
      return _objectSpread(_objectSpread({}, template), {}, {
        avatarColor: colorList[index]
      });
    });
  }, [templates]);
  var searchedTemplates = (0, _react.useMemo)(function () {
    var resultTemplates = acquiredTemplates;

    if (!isAllowEditTemplate) {
      resultTemplates = resultTemplates.filter(function (_ref3) {
        var name = _ref3.name;
        return name !== 'Blank Template';
      });
    }

    return resultTemplates.filter(function (_ref4) {
      var name = _ref4.name,
          templateOwnerType = _ref4.type;
      return name.toLowerCase().includes(search.toLowerCase()) && (ownerType === 'all' || templateOwnerType === ownerType);
    });
  }, [acquiredTemplates, ownerType, search, isAllowEditTemplate]);
  var showEmptySearch = (0, _react.useMemo)(function () {
    return !isLoading && searchedTemplates.length === 0;
  }, [searchedTemplates, isLoading]);
  var setTemplateHandler = (0, _react.useCallback)(function (template) {
    trackStepPassed({
      templateType: template.type
    });
    setTemplate(template);
  }, [setTemplate, trackStepPassed]);
  (0, _react.useEffect)(function () {
    if (isDirectMailInvitationType) {
      dispatch((0, _gift.selectTemplate)(_objectSpread({}, _templates3.defaultBlankTemplate)));
    }
  }, [dispatch, isDirectMailInvitationType]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    py: 3,
    pl: 6,
    pr: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    pb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "H4-Chambray"
  }, "Select a template for your message")), /*#__PURE__*/_react.default.createElement(_ui.SearchField, {
    value: search,
    placeholder: "Search your templates",
    onChange: function onChange(e) {
      return setSearch(e.target.value);
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    p: 2,
    borderTop: "1px solid #eceae7"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Label-Table-Left-Active"
  }, "YOUR TEMPLATES"), templates.length > 1 && /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_material.Select, {
    id: "template-owner-select",
    value: ownerType,
    onChange: function onChange(event) {
      return setOwnerType(event.target.value);
    }
  }, /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
    value: "all"
  }, "View all templates"), templateTypes.includes('personal') && /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
    value: "personal"
  }, "Personal templates"), templateTypes.includes('team') && /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
    value: "team"
  }, "Team templates"), templateTypes.includes('campaign') && /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
    value: "campaign"
  }, "Campaign templates")))), /*#__PURE__*/_react.default.createElement(_SelectItemsList.default, {
    isLoading: isLoading,
    isLoaded: isLoaded
  }, searchedTemplates.map(function (template, index) {
    return /*#__PURE__*/_react.default.createElement(_EmailTemplateListItem.default, {
      key: template.name,
      template: template,
      onSelect: setTemplateHandler,
      backgroundColor: template.avatarColor,
      divider: index !== 0
    });
  })), showEmptySearch && /*#__PURE__*/_react.default.createElement(_EmptyListSearch.default, {
    search: search
  }));
};

SelectEmailTemplate.propTypes = {
  giftId: _propTypes.default.string.isRequired
};
var _default = SelectEmailTemplate;
exports.default = _default;